import { STORE_KEY_LANG } from '@/constants';

export default {
  getLangs() {
    return this.$i18n.availableLocales;
  },
  getLang() {
    return window.localStorage.getItem(STORE_KEY_LANG) || 'bg';
  },
  setLang(val) {
    window.localStorage.setItem(STORE_KEY_LANG, val);
    this.$i18n.locale = val;
  },
}